import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AfterFilterChangeDirective } from './after-filter-change.directive'

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        AfterFilterChangeDirective
        
    ],
    exports: [
        AfterFilterChangeDirective
    ]

})
export class AfterFilterChangeDirectiveModule {
    static forRoot(): ModuleWithProviders<AfterFilterChangeDirectiveModule> {
    return {
        ngModule: AfterFilterChangeDirectiveModule
    };
}
}
